// colors used on the website

const colors = {
  primary: '#00bc77',
  secondary: '#000',
  tertiary: '#fff',
  mainBackground: '#12002b',
  mainBackgroundDarkMode: '#2F2E41',
  darkModeHighlights: '#4F4C6B',
  warning: 'red',
  
  // Link
  activeA: '#42b983',
  aLink: '#2c3e50',

  // Feature
  itemTitle: '#222',

}

export default colors
